<div class="DateTimeStrip" [attr.aria-labelledby]="selectedDateTime">
    <input type="time" onClick="select()" (input)="onTimeInputChange($event.target)" class="DateTimeStrip__timePicker" value="{{ currentStringTime }}">
    <input type="date" id="datePicker" onClick="select()" (input)="onDateInputChange($event.target)" class="DateTimeStrip__datePicker" value="{{ currentStringDate }}">
</div>
